export default class Observable<T> {
  private listeners: any[] = [];

  public attach(callback: any) {
    this.listeners.push(callback);
  }

  public notify(value: T) {
    for (const listener of this.listeners) {
      listener(value);
    }
  }

  public detach(callback: any) {
    this.listeners = this.listeners.filter((l) => l !== callback);
  }
}
